<div fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="column" fxLayoutGap="15px">
    <div fxLayout="row">
      <app-dict-insurance-companies
        fxFlex="100" label="TU" [required]="true"
        [control]="insuranceCompanyControl"
        (selectedInsuranceCompany)="insuranceCompanyChanged($event)"
        [hideChildren]="true"
      ></app-dict-insurance-companies>
    </div>

    <div fxLayout="row">
      <app-dict
        fxFlex="100"
        [control]="importerControl"
        [dictType]="'commission_importer_' + selectedInsuranceCompany?.key"
        matTooltip="Najpierw wybierz TU"
        matTooltipPosition="left"
        [matTooltipDisabled]="!!selectedInsuranceCompany"
        label="Importer"
      ></app-dict>
    </div>

    <div fxLayout="row">
      <app-dict
        fxFlex="100" label="Ryzyko"
        dictType="internal_risk" [required]="true"
        [control]="internalRiskControl"
      ></app-dict>
    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!riskForm.valid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>

    <button (click)="closeDialog()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

